<template>
  <nav id="menu-derek" class="menu-container">
    <div class="top-nav d-none d-md-flex">
      <div
        v-if="topbar"
        id="topbar-editable"
        style="width: 100%; min-height: 50px"
        v-html="topbar.html"
      ></div>
      <div class="nav-segundo-nivel">
        <ul class="container-max-width">
          <li>
            <a
              href="https://preaprobado.quac.co/?store_business=baguer&slug_store=derek"
              class="item-nav-segundo-nivel"
            >
              Solicita tu cupo
            </a>
          </li>
          <li>
            <router-link
              :to="{ name: 'Tiendas' }"
              class="item-nav-segundo-nivel"
            >
              Encuentra una tienda
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'FollowOrder' }"
              class="item-nav-segundo-nivel"
            >
              Rastrear pedido
            </router-link>
          </li>
          <li>
            <a href="https://portalpagos.derek.co" class="pagar-cuota">
              Paga tu cuota
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="menu-desktop container-max-width">
      <div class="d-flex align-items-center h-100">
        <div
          class="d-flex d-md-none pe-3"
          @click="
            btnMenuMovil = !btnMenuMovil
            showOptionsUser = false
          "
        >
          <svg
            v-show="!btnMenuMovil"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="22.21"
            viewBox="0 0 25 22.21"
          >
            <path
              id="menu"
              d="M0,22.21v-2H25v2ZM0,12.105v-2H25v2ZM0,2V0H25V2Z"
              fill="#654062"
            />
          </svg>
          <svg
            v-show="btnMenuMovil"
            xmlns="http://www.w3.org/2000/svg"
            width="25.675"
            height="25.622"
            viewBox="0 0 25.675 25.622"
          >
            <path
              id="menu"
              d="M16.052,16.241,4.693,27.578l-1.506-1.5,11.36-11.338L3.244,3.457,4.7,2.011,16,13.292,27.354,1.957l1.506,1.5L17.5,14.793l11.36,11.339-1.451,1.446Z"
              transform="translate(-3.187 -1.957)"
              fill="#654062"
            />
          </svg>
        </div>
        <router-link
          :to="{ name: 'Home' }"
          style="color: transparent; position: relative;"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="31.1"
            viewBox="0 0 100 31.1"
            @click="
              showOptionsUser = false
              btnMenuMovil = false
            "
          >
            <path
              id="XMLID_4_"
              d="M27.461,18.121l14.485.112v-.28a5.876,5.876,0,0,0-1.9-4.7,7.779,7.779,0,0,0-5.313-1.734,7.222,7.222,0,0,0-5.145,1.79,6.776,6.776,0,0,0-2.125,4.81ZM77.908,30.7l.056-4.978A7.155,7.155,0,0,1,75,29.418Q72.232,31.18,67.282,31.1a11.756,11.756,0,0,1-8.389-2.908,10.537,10.537,0,0,1-3.02-7.942A11.029,11.029,0,0,1,58.5,12.64h-.28q-4.362,0-6.376,1.846c-1.342,1.286-2.069,3.3-2.069,6.04l-.056,9.955H45.582l.056-9.676-18.345-.112a7.482,7.482,0,0,0,2.013,5.481A7.734,7.734,0,0,0,34.9,28.132a7.881,7.881,0,0,0,4.362-1.063,4.353,4.353,0,0,0,2.013-3.076l4.362.056a7.324,7.324,0,0,1-3.356,5.257q-2.768,1.762-7.718,1.678a11.756,11.756,0,0,1-8.389-2.908A8.939,8.939,0,0,1,24.049,25c0,1.063,0,2.013.056,2.8.056.951.168,1.846.28,2.685H20.246l-.28-3.244a10,10,0,0,1-3.747,2.8,12.551,12.551,0,0,1-4.978.895A11.23,11.23,0,0,1,3.02,27.852,11.513,11.513,0,0,1,0,19.575a10.365,10.365,0,0,1,3.188-8c2.069-2.013,4.866-2.964,8.333-2.964a11.54,11.54,0,0,1,4.7.895,12.5,12.5,0,0,1,3.915,2.573L20.19,0h4.027l-.112,15.1a10.11,10.11,0,0,1,2.349-3.356,12.406,12.406,0,0,1,8.781-3.02c3.523,0,6.208,1.007,8.054,2.852a9.4,9.4,0,0,1,2.4,4.474c0-1.007,0-2.013-.056-3.076-.056-1.23-.112-2.461-.28-3.691H49.5l.168,3.971A7.542,7.542,0,0,1,52.908,9.9a11.712,11.712,0,0,1,5.425-1.063h.783v3.076l.056-.056a12.406,12.406,0,0,1,8.781-3.02c3.523,0,6.208,1.007,8.054,2.852a9.707,9.707,0,0,1,2.013,3.132L78.132.168h4.027L82.047,17.9,93.009,9.452l5.369.056-11.745,9L100,30.7l-5.872-.056L82.047,19.016l-.112,11.745Zm.056-6.488V21.029l-17.953-.112A7.263,7.263,0,0,0,62.025,26.4a7.734,7.734,0,0,0,5.593,1.957,7.881,7.881,0,0,0,4.362-1.063,4.353,4.353,0,0,0,2.013-3.076ZM60.179,18.345l14.485.112v-.28a5.876,5.876,0,0,0-1.9-4.7,8.069,8.069,0,0,0-5.313-1.734,7.314,7.314,0,0,0-5.145,1.79,6.776,6.776,0,0,0-2.125,4.81ZM4.195,19.687a8.2,8.2,0,0,0,2.069,5.984,7.717,7.717,0,0,0,5.817,2.181,8.158,8.158,0,0,0,5.928-2.181A7.749,7.749,0,0,0,20.3,19.855,8.323,8.323,0,0,0,18.177,13.7a7.846,7.846,0,0,0-5.984-2.237A7.936,7.936,0,0,0,6.32,13.647a8.367,8.367,0,0,0-2.125,6.04Z"
              fill="#131314"
            />
          </svg>
          <span style="position: absolute;">Derek</span>
        </router-link>
        <div v-if="menuDerek" class="d-none d-md-flex h-100">
          <div id="cant-menu" class="categorys-menu">
            <ul v-for="(item, index) in menuDerek" :key="index">
              <li
                @click="
                  clickMenu()
                  showOptionsUser = false
                "
              >
                <router-link
                  class="category-menu"
                  :class="item.destacado == 1 ? 'd-flex' : ''"
                  :style="
                    item.color_fondo
                      ? `background-color: ${item.color_fondo}; color: ${item.color_texto}; border-radius: 20px; padding: .3rem .5rem; border: none !important; font-family: 'PT Sans', sans-serif !important;`
                      : ''
                  "
                  :to="{
                    name: item.routerName,
                    params: {
                      category: item.slug,
                      nameCreative: `menu-${item.slug}`,
                      slot: `menu`,
                      id: `${item.slug}`,
                      name: `menu ${item.slug}`,
                    },
                  }"
                >
                  {{ item.descripcion }}
                  <img
                    v-if="item.destacado == 1"
                    class="novelity"
                    src="@/assets/icons/novelty-icon.svg"
                    :alt="item.descripcion"
                  />
                </router-link>
                <sub-menu-desktop
                  v-if="item.subMenu && !click"
                  :categorias-destacadas="
                    item.categorias_destacadas ? item.categorias_destacadas : []
                  "
                  :data-sub-menu="item.subMenu"
                  :category="item.slug"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div
          class="d-none d-md-flex"
          style="border-left: 2px dotted #949494; border-right: 2px dotted #949494; cursor: pointer;"
        >
          <router-link
            class="my-auto"
            :to="{
              name: 'TiendaCategory',
              params: {
                category: 'lovely',
                nameCreative: `menu-lovely`,
                slot: `menu`,
                id: `lovely`,
                name: `menu lovely`,
              },
            }"
          >
            <img
              src="@/assets/icons/lovely.svg"
              style="min-width: 83px; min-height: 45px;"
              class="px-3"
              alt="Logo categoría lovely"
            />
          </router-link>
        </div>
        <button
          class="icons-menu"
          aria-label="Usuario"
          @click="
            showOptionsUser = !showOptionsUser
            btnMenuMovil = false
          "
        >
          <img
            v-if="dataUser"
            style="min-width: 26px"
            src="@/assets/icons/user-icon-logged.svg"
            alt="boton de usuario logueado"
          />
          <img
            v-else
            style="min-width: 26px"
            src="@/assets/icons/user-icon.svg"
            alt="boton de usuario login"
          />
        </button>
        <button
          id="search_doofinder"
          class="icons-menu"
          aria-label="Search"
          @click="
            clickSearch()
            btnMenuMovil = false
          "
        >
          <img
            style="min-width: 26px"
            src="@/assets/icons/search-icon.svg"
            alt="boton de busqueda"
          />
        </button>
        <router-link class="my-auto" :to="{ name: 'PerfilFavorites' }">
          <button
            class="icons-menu"
            aria-label="Favoritos"
            @click="
              showOptionsUser = false
              btnMenuMovil = false
            "
          >
            <img
              style="min-width: 26px"
              src="@/assets/icons/favorite-icon.svg"
              alt="boton de favoritos"
            />
            <span v-if="productWhislist.length > 0" class="tag-menu">{{
              productWhislist.length
            }}</span>
          </button>
        </router-link>
        <router-link class="my-auto" :to="{ name: 'MyBag' }">
          <button
            class="icons-menu"
            aria-label="Bolsa"
            @click="
              showOptionsUser = false
              btnMenuMovil = false
            "
          >
            <img
              style="min-height: 26px; min-width: 21px;"
              src="@/assets/icons/shopping-bag.svg"
              alt="boton de carrito"
            />
            <span
              v-if="productsCart && productsCart.length > 0"
              class="tag-menu"
              style="bottom: -.5rem"
              >{{ productsCart.length }}</span
            >
          </button>
        </router-link>
      </div>
    </div>
    <menu-movil
      v-if="menuDerek"
      class="movil-menu"
      :style="btnMenuMovil ? 'width: 100%; left: 0' : 'width: 0; left: -100%'"
      :data-menu="menuDerek"
      :open-menu="btnMenuMovil"
      @closeMenu="btnMenuMovil = $event"
    />
    <user-menu
      :show-options-user="showOptionsUser"
      @clickOut="showOptionsUser = $event"
    />
    <search-products />
  </nav>
</template>
<script>
import { mapState } from 'vuex'
import { GA4ViewPromotion } from '@/GA4/events'
import { sendFBQEvent } from '@/fbq'

import SubMenuDesktop from '@/components/Menu/SubMenuDesktop.vue'
import MenuMovil from '@/components/Menu/MenuMovil.vue'
import UserMenu from '@/components/Menu/Shortcuts/UserMenu.vue'
import SearchProducts from '@/components/Menu/SearchProducts.vue'

export default {
  name: 'MenuBase',
  components: { SubMenuDesktop, MenuMovil, UserMenu, SearchProducts },
  data() {
    return {
      btnMenuMovil: false,
      showOptionsUser: false,
      click: false,
      sendGA4Topbar: false,
    }
  },
  computed: {
    ...mapState('layouts', ['menuDerek', 'menuLayoutDerek', 'topbar']),
    ...mapState('user', ['dataUser']),
    ...mapState('products', ['productWhislist']),
    ...mapState('cart', ['productsCart']),
    ...mapState(['loaderDerek']),
  },
  watch: {
    async click() {
      this.validateTop()
    },
    async $route() {
      this.btnMenuMovil = false
      this.showOptionsUser = false
      this.validateTop()
    },
    async loaderDerek() {
      this.validateTop()
    },
    async showOptionsUser() {
      if (this.showOptionsUser) {
        await setTimeout(() => {
          var currentScrollPos = window.pageYOffset
          let userMenuDerek = document.getElementById('user-menu-derek')
          let modalUserMenuDerek = document.getElementById('modal-bg-derek')
          if (window.innerWidth > 768) {
            if (this.topbar) {
              if (
                window.scrollY >
                document.getElementById('topbar-editable').offsetHeight + 120
              ) {
                userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
                modalUserMenuDerek
                  ? (modalUserMenuDerek.style.top = '70px')
                  : ''
              } else {
                userMenuDerek
                  ? (userMenuDerek.style.top = this.topbar
                      ? document.getElementById('topbar-editable')
                          .offsetHeight +
                        120 -
                        currentScrollPos +
                        'px'
                      : '120px')
                  : ''
                modalUserMenuDerek
                  ? (modalUserMenuDerek.style.top = this.topbar
                      ? document.getElementById('topbar-editable')
                          .offsetHeight +
                        120 -
                        currentScrollPos +
                        'px'
                      : '120px')
                  : ''
              }
            } else if (window.scrollY > 120) {
              userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
              modalUserMenuDerek ? (modalUserMenuDerek.style.top = '70px') : ''
            } else {
              userMenuDerek
                ? (userMenuDerek.style.top = this.topbar
                    ? document.getElementById('topbar-editable').offsetHeight +
                      120 +
                      'px'
                    : '120px')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.top = this.topbar
                    ? document.getElementById('topbar-editable').offsetHeight +
                      120 +
                      'px'
                    : '120px')
                : ''
            }
          } else {
            userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
            modalUserMenuDerek ? (modalUserMenuDerek.style.top = '70px') : ''
          }
          userMenuDerek.style.display = 'block'
        }, 1)
      }
    },
    async topbar() {
      if (this.topbar && !this.sendGA4Topbar) {
        this.sendGA4Topbar = true
        const parser = new DOMParser()
        const doc = parser.parseFromString(this.topbar.html, 'text/html')
        const h2Content = doc.querySelector('h2').textContent
        GA4ViewPromotion({
          nameCreative: `topBar page ${this.topbar.id}`,
          slot: `topbar-page-${this.topbar.id}`,
          id: `topBar-${this.topbar.id}`,
          name: `${h2Content}`,
          items: [],
        })
      }
      this.validateTop()
    },
    async menuDerek() {
      await this.validateTop()
    },
  },
  mounted() {
    var prevScrollpos = window.pageYOffset
    window.document.onscroll = () => {
      var currentScrollPos = window.pageYOffset
      if (
        this.menuLayoutDerek == 'menu-base' &&
        document.getElementsByClassName('movil-menu')[0].style.left != '0px'
      ) {
        let navBar = document.getElementById('menu-derek')
        let filters = document.getElementById('nav-filters-desktop')
        // let filtersSidebar = document.getElementById("sidebar-menu-movil");
        // let size_guide_movil = document.getElementById("size-guide-product-detail-movil");
        // let size_guide_desktop = document.getElementById("size-guide-product-detail-desktop");
        let submenu_movil = document.getElementById('sub-menu-movil')
        let dataProduct = document.getElementById('id-product-detail-data')
        let userMenuDerek = document.getElementById('user-menu-derek')
        let modalUserMenuDerek = document.getElementById('modal-bg-derek')
        if (
          currentScrollPos < prevScrollpos &&
          !document.getElementById('user-menu-derek')
        ) {
          if (window.innerWidth > 768) {
            navBar.style.top = this.topbar ? '-100px' : '-50px'
            if (window.scrollY > 100) {
              userMenuDerek
                ? (userMenuDerek.style.transitionDuration = '.4s')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.transitionDuration = '.4s')
                : ''
              userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
              modalUserMenuDerek ? (modalUserMenuDerek.style.top = '70px') : ''
            } else {
              userMenuDerek
                ? (userMenuDerek.style.transitionDuration = '0s')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.transitionDuration = '0s')
                : ''
              userMenuDerek
                ? (userMenuDerek.style.top =
                    (this.topbar ? 70 : 50) + (100 - window.scrollY) + 'px')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.top =
                    (this.topbar ? 70 : 50) + (100 - window.scrollY) + 'px')
                : ''
            }
          } else {
            document.getElementsByClassName(
              'movil-menu',
            )[0].style.paddingBottom = '70px'
            navBar.style.top = '0px'
            userMenuDerek
              ? (userMenuDerek.style.transitionDuration = '.4s')
              : ''
            modalUserMenuDerek
              ? (modalUserMenuDerek.style.transitionDuration = '.4s')
              : ''
            userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
            modalUserMenuDerek ? (modalUserMenuDerek.style.top = '70px') : ''
          }
          filters ? (filters.style.top = '69px') : ''
          // filtersSidebar ? filtersSidebar.style.top = '70px' : '';
          dataProduct ? (dataProduct.style.top = '70px') : ''
          // size_guide_movil ? size_guide_movil.style.top = '70px' : '';
          // size_guide_desktop ? size_guide_desktop.style.top = '70px' : '';
          submenu_movil ? (submenu_movil.style.top = '70px') : ''
          submenu_movil
            ? (submenu_movil.style.height = 'calc(100% - 70px)')
            : ''
        } else {
          if (window.innerWidth > 768) {
            if (!userMenuDerek) {
              navBar.style.top = this.topbar ? '-170px' : '-120px'
            }
            if (window.scrollY > 100) {
              userMenuDerek
                ? (userMenuDerek.style.transitionDuration = '.4s')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.transitionDuration = '.4s')
                : ''
              userMenuDerek ? (userMenuDerek.style.top = '70px') : ''
              modalUserMenuDerek ? (modalUserMenuDerek.style.top = '70px') : ''
            } else {
              userMenuDerek
                ? (userMenuDerek.style.transitionDuration = '0s')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.transitionDuration = '0s')
                : ''
              userMenuDerek
                ? (userMenuDerek.style.top =
                    (this.topbar ? 70 : 50) + (100 - window.scrollY) + 'px')
                : ''
              modalUserMenuDerek
                ? (modalUserMenuDerek.style.top =
                    (this.topbar ? 70 : 50) + (100 - window.scrollY) + 'px')
                : ''
            }
          } else {
            userMenuDerek
              ? (userMenuDerek.style.transitionDuration = '.4s')
              : ''
            modalUserMenuDerek
              ? (modalUserMenuDerek.style.transitionDuration = '.4s')
              : ''
            if (window.scrollY > 10) {
              document.getElementsByClassName(
                'movil-menu',
              )[0].style.paddingBottom = '0px'
              navBar.style.top = '-70px'
              userMenuDerek ? (userMenuDerek.style.top = '0px') : ''
              modalUserMenuDerek ? (modalUserMenuDerek.style.top = '0px') : ''
            }
          }
          filters ? (filters.style.top = '0') : ''
          dataProduct ? (dataProduct.style.top = '0') : ''
          // filtersSidebar ? filtersSidebar.style.top = '0' : '';
          // size_guide_movil ? size_guide_movil.style.top = '0' : '';
          // size_guide_desktop ? size_guide_desktop.style.top = '0' : '';
          submenu_movil ? (submenu_movil.style.top = '0') : ''
          submenu_movil ? (submenu_movil.style.height = '100%') : ''
        }
        prevScrollpos = currentScrollPos
      }
    }
    this.validateTop()
  },
  methods: {
    async clickMenu() {
      this.click = true
      let elThis = this
      await setTimeout(function() {
        elThis.click = false
      }, 1000)
    },
    clickSearch() {
      this.showOptionsUser = false
      sendFBQEvent(this, 'Search', {})
    },
    async validateTop() {
      let submenu_desktop = document.querySelectorAll('.sub-menu-desktop')
      if (submenu_desktop.length > 0 && this.topbar) {
        submenu_desktop.forEach(element => {
          let heightTopbar = document.getElementById('topbar-editable')
          element.style.top =
            this.topbar && heightTopbar
              ? parseInt(heightTopbar.offsetHeight + 120) + 'px'
              : '120px'
        })
      } else {
        await setTimeout(() => this.validateTop(), 100)
      }
    },
  },
}
</script>
